var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.505.351a1.2 1.2 0 010 1.698L15.262 12.29a3.2 3.2 0 01-4.525 0L.498 2.052A1.2 1.2 0 012.195.355l10.239 10.24a.8.8 0 001.131 0L23.808.35a1.2 1.2 0 011.697 0z",
    fill: "#5F2698"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAyNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNS41MDUgMC4zNTE0NzJDMjUuOTczNiAwLjgyMDEwMiAyNS45NzM2IDEuNTc5OSAyNS41MDUgMi4wNDg1M0wxNS4yNjIzIDEyLjI5MTJDMTQuMDEyNyAxMy41NDA5IDExLjk4NjUgMTMuNTQwOSAxMC43MzY5IDEyLjI5MTJMMC40OTc5NTYgMi4wNTIyN0MwLjAyOTMyNzEgMS41ODM2NCAwLjAyOTMyNjkgMC44MjM4NDMgMC40OTc5NTcgMC4zNTUyMTNDMC45NjY1ODYgLTAuMTEzNDE2IDEuNzI2MzggLTAuMTEzNDE2IDIuMTk1MDEgMC4zNTUyMTNMMTIuNDMzOSAxMC41OTQxQzEyLjc0NjMgMTAuOTA2NSAxMy4yNTI5IDEwLjkwNjUgMTMuNTY1MyAxMC41OTQxTDIzLjgwNzkgMC4zNTE0NzJDMjQuMjc2NiAtMC4xMTcxNTggMjUuMDM2NCAtMC4xMTcxNTcgMjUuNTA1IDAuMzUxNDcyWiIgZmlsbD0iIzVGMjY5OCIvPgo8L3N2Zz4K";
export { SvgDownArrow as ReactComponent };